import styles from './ChatExplorer.module.css';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import newChatWithAgent from "../../assets/newChatWithAgent.svg"
// import { fetchByMenu } from '../../../../slices/chatSlice';
// import { clearCurrentChat } from '../../../../slices/chatSlice';
import apiBackend from "@src/apiBackend.js";

import {
  fetchByMenu,
  deleteChat,
  getImagesAgents,
  getPublicAgents,
  emptyChat,
  fetchByChat
} from '../../../../actions/chat';
import { setMessages, setSelectedAgent, clearCurrentChat, setChatList, setEmptyChat } from '../../../../slices/chatSlices';

import Button from "../../components/Button/Button.jsx";
import { ReactComponent as ArrowLeft } from "../../assets/ArrowLeftWhite.svg";
// import ExploreCommuniti from "../../screens/ChatView/ExploreCommuniti/ExploreCommuniti.jsx"


import useFocusShortcut from "../../../../utils/useFocusShortcut.js";

import SearchIconWithIcon from "../../components/SearchIconWithIcon/SearchIconWithIcon.jsx";

import agentNewIcon from "../../assets/agentNewIcon.svg";

import { ReactComponent as ExploreCommunitiIcon } from "../../assets/exploreCommunitiIcon.svg";

import { duplicateAgent, getAgents } from "../../../../actions/agents.js";
// import l from "../../assets/lIcon.svg";
import ImageEmpty from "../../assets/ImageEmpty.svg";

import { ReactComponent as Pinned } from "../../assets/PinnedIcon.svg";

import { ReactComponent as NotPinned } from "../../assets/NotPinned.svg";

import horizontalDots from "../../assets/S3/horizontalDots.svg";


import { setShowModal } from "../../../../slices/userSlices";
import { getAgentById } from "../../../../actions/chat";
import { set } from 'date-fns';
// import { setSelectedAgent } from "../../../../slices/chatSlices";


const ChatExplorer = ({
  // chatId,
  // agentId,
  leftWidth,
  // selectedAgent,
  // setSelectedAgent,
  // setIdSelectedAgent,
  // setMessages,
  // setChatAgentId,
  // setShowDeleteChatsAgents,
  // setSTypeDeleteChatsAgents,
  // setSelectedChatAgentToDelete,
  // setChats,
  // chats,
  handleSendMessage,
  setNewChat,
  // user,
  // setVarianteDeleteChatsAgent,
  
}) => {

  const { agentId: agentIdParam } = useParams();
  const [t] = useTranslation("ChatView");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { selectedAgent, currentChat, chatList, searchTerm: searchTermState, messages } = useSelector(
    (state) => state.chat
  );


  // let leftWidth = 250;

  const { user, globalSearch } = useSelector((state) => state.user);
  const [showExplore, setShowExplore] = useState(false)

  const [agentId, setAgentId] = useState(null);
  const [chatId, setChatId] = useState(null);


  useEffect(() => {
    setSearchTerm(globalSearch)
  },[globalSearch])

  // useEffect(() => {
  //   console.log("selectedAgent", selectedAgent);
  //   if (selectedAgent) {
  //     setAgentId(selectedAgent._id);
  //   }
  // }, [selectedAgent]);

  useEffect(() => {
    // console.log("agentIdParam", agentIdParam);
    const fn = async () => {
      if (agentIdParam) {
        const response = await dispatch(
          getAgentById({
            idSelectedAgent: agentIdParam,
            // setUserData: setSelectedAgent,
            // setlanguage,
          })
        );

        if (response.payload && response.payload.success) {
          dispatch(setSelectedAgent(response.payload.agent));
        }
      }
    }
    fn();
  }, [agentIdParam]);

  useEffect(() => {
    console.log("selectedAgent", selectedAgent);
    if (selectedAgent) {
      setAgentId(selectedAgent._id);
    }
  }, [selectedAgent]);


  useEffect(() => {
    if (currentChat) {
      setChatId(currentChat.id);
    }
  }, [currentChat]);





  useEffect(() => {
    dispatch(fetchByMenu({ query: searchTermState }));
  }, [searchTermState, dispatch]);

  useEffect(() => {
    if (chatList.length > 0) {
      dispatch(setChatList(chatList));
      // setChats(chatList);
    }
  }, [chatList]);

  const sortChat =
    chatList.length === 0
      ? []
      : Object.values(
        chatList.reduce((acc, chat) => {
          if (chat.typeChat === "agentConfiguration") return acc;

          const olderGroup = chat.older || 0;
          if (!acc[olderGroup]) acc[olderGroup] = [];
          acc[olderGroup].push(chat);
          return acc;
        }, {})
      );

  const searchInputRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    dispatch(clearCurrentChat());
  }, []);

  const addMessage = () => {
    dispatch(clearCurrentChat());
    navigate(`/admin/agent`, { state: { backgroundLocation: location } });
  };

  const handleDeleteMessage = async (chatId) => {

    await dispatch(deleteChat({ chatId: chatId.id }));
    setSelectedOption(false);
  };

  const [selectedChat, setSelectedChat] = useState(null);
  const [tempChatNames, setTempChatNames] = useState({});
  const inputRefs = useRef({});

  const handleChangeName = async (chatId) => {
    setSelectedOption(false);
    setSelectedChat(chatId);

    const selectedChat = chatList.find((chat) => chat.id === chatId);
    if (selectedChat) {
      setTempChatNames((prev) => ({ ...prev, [chatId]: selectedChat.name }));
    }
  };

  useEffect(() => {
    if (selectedChat && inputRefs.current[selectedChat]) {
      inputRefs.current[selectedChat].focus();
    }
  }, [selectedChat]);

  useFocusShortcut(searchInputRef, "/");

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isMobile = windowWidth <= 768;

  const [swiped, setSwiped] = useState(false);


  const [selectedOption, setSelectedOption] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectedOption && !event.target.closest(`.${styles.menuOptions}`)) {
        setSelectedOption(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectedOption]);


  const {
    agents,
    loading: loadingAgent,
    error,
  } = useSelector((state) => state.agents);

  const userToken = localStorage.getItem("user");
  const userJson = JSON.parse(userToken);
  const token = userJson?.accessToken;
  const [privateAgentsFiltered, setPrivateAgentsFiltered] = useState([]);
  const [publicAgentsFiltered, setPublicAgentsFiltered] = useState([]);
  const [filteredAgents, setFilteredAgents] = useState([]);
  const location = useLocation()
  const [optionsSelectedAgent, setOptionsSelectedAgent] = useState(false);

  // useEffect(() => {
  //   dispatch(setSelectedAgent(selectedAgentSlice));
  // //   dispatch(setSelectedAgentSlice(""));
  // }, [selectedAgentSlice]);






  useEffect(() => {
    if (token) {
      dispatch(getAgents({ token }));
    }
  }, [dispatch, token]);



  useEffect(() => {
    const filtered =
      searchTerm.trim() === ""
        ? agents.agents
        : agents.agents.filter((agent) =>
          agent.name.toLowerCase().includes(searchTerm.toLowerCase())
        );

    const agentIds = filtered?.map((agent) => agent._id);

    if (agentIds?.length > 0) {
      const fetchImages = async () => {
        try {
          const response = await dispatch(getImagesAgents({ agentIds }));
          const images = response.payload.images;

          const updatedAgents = filtered.map((agent) => {
            const image = images.find((img) => img._id === agent._id)?.image;
            return {
              ...agent,
              image,
            };
          });

          setPrivateAgentsFiltered(updatedAgents);
        } catch (error) {
          console.error("Error al obtener las imágenes de los agentes:", error);
        }
      };

      fetchImages();
    } else {
      setPrivateAgentsFiltered(filtered);
    }
  }, [searchTerm, agents, dispatch]);

  useEffect(() => {
    const searchPublicAgent = async () => {
      if (searchTerm) {

        const response = await dispatch(getPublicAgents({ searchTerm: searchTerm || 'test' }));

        if (response.payload.success && response.payload.agents.length > 0) {
          setPublicAgentsFiltered(response.payload.agents);
        } else {
          setPublicAgentsFiltered([]);
        }
      }
    };

    searchPublicAgent();
  }, [searchTerm]);

  useEffect(() => {
    setFilteredAgents([
      ...(privateAgentsFiltered || []),
      ...(publicAgentsFiltered || [])
    ]);
  }, [privateAgentsFiltered, publicAgentsFiltered]);

  const handleTogglePinned = async (agentId, currentPinned = false) => {
    if (!token) {
      console.error("Token no disponible, evitando la petición");
      return;
    }

    try {

      const res = await apiBackend.put(
        `/chat/pin-agents/${agentId}`,
        { pinned: !currentPinned },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(getAgents({ token }));
    } catch (error) {
      console.error("Error en la petición PUT:", error.response?.data || error);
    }
  };
  const handleTogglePinnedChat = async (chatId, currentPinned = false) => {
    if (!token) {
      console.error("Token no disponible, evitando la petición");
      return;
    }

    try {

      const res = await apiBackend.put(
        `/chat/${chatId}/pin`,
        { pinned: !currentPinned },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(fetchByMenu({ query: searchTermState }));
      setSelectedOption(null);
    } catch (error) {
      console.error("Error en la petición PUT:", error.response?.data || error);
    }
  };


  const handleChageNameChat = async (chatId, name) => {
    if (!token) {
      console.error("Token no disponible, evitando la petición");
      return;
    }

    try {

      const res = await apiBackend.put(
        `/chat/${chatId}/update-name`,
        { name },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(fetchByMenu({ query: searchTermState }));
    } catch (error) {
      console.error("Error en la petición PUT:", error.response?.data || error);
    }
  };

  const hasMatchingChats = Object.values(sortChat)
    .flat()
    .filter((chat) => chat?.agent === selectedAgent?._id)
    .some((chat) =>
      (chat.name || "").toLowerCase().includes(searchTerm.toLowerCase())
    );

  const [image, setImage] = useState(null);

  useEffect(() => {
    const fetchAgentImage = async () => {
      if (!agentId) return;
      try {
        const responseImage = await dispatch(
          getImagesAgents({ agentIds: agentId })
        );
        const agentImage = responseImage.payload?.images?.[0]?.image;
        if (agentImage) {
          setImage(agentImage);
        } else {
          setImage(null);
        }
      } catch (error) {
        console.error("Error fetching agent image:", error);
        setImage(null);
      }
    };
    fetchAgentImage();
  }, [agentId, dispatch]);

  const agent = selectedAgent || selectedOption?.agent;

  const onClicNewChat = (e) => {       
    //const handleSendMessage = async (text = false, agent, agentId, file) => {
      setNewChat(true)
    handleSendMessage("","", selectedAgent.name,agentId,"",true )
    // const new_id = uuidv4();
    // localStorage.setItem("selectedChatId", "");
  // navigate(`/admin/chat/${agentId}/${new_id}`);
  }


  return (
    <div
      className={styles.chatMenu}
      style={{
        maxWidth: `${leftWidth || 0}px`,
        width: isMobile && "0px",
        minWidth: isMobile && "0px",
      }}
    >
      <div
        className={`${styles.asideBar} ${isMobile ? styles.mobileMenu : ""} ${swiped ? "" : styles.offAsideBar}`}
      >
        <SearchIconWithIcon
          ref={searchInputRef}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          iconRight={agentNewIcon}
          classNameIconRight={styles.searchContainerL}
          onClickIconRight={() => addMessage()}
          selectedAgent={selectedAgent}
          customShadowContainer={{width: "29px",height: "30px",left: "49%"}}
        // handleSendMessage={handleSendMessage}
        >
          <div
            style={{ marginLeft: "5px" }}
            className={styles.searchIconsWrappers}
            >
            /
            {/* aca */}
            {/* <img src={l} alt="kIcon" /> */}
          </div>
        </SearchIconWithIcon>

        <div className={styles.chatsContainer}>
          {selectedAgent && (
            <>
              <div className={styles.goToAgents}>
                <Button
                  action={() => {
                    navigate("/admin/chat");
                    dispatch(setSelectedAgent(null));
                    dispatch(setMessages([]));
                    localStorage.removeItem("selectedAgentId");
                    localStorage.removeItem("selectedChatId");
                    dispatch(clearCurrentChat());
                  }}
                  headerStyle={{ padding: "4px 5px" }}
                >
                  <ArrowLeft />
                </Button>
                <div className={styles.selectedAgentContainer}>
                  <img src={image || ImageEmpty} alt="" />
                  {selectedAgent.name}
                  <div className={styles.pinnedIcon}>
                    {selectedAgent.pinned ? <Pinned className={styles.pinnedIconSvg} /> : <NotPinned />}
                  </div>
                  <div className={styles.chatMenuSettings}>
                    <button
                      className={styles.moreButton}
                      onClick={(e) => {
                        e.stopPropagation();
                        setOptionsSelectedAgent(true);
                        setSelectedOption({
                          selectedAgent,
                          x: e.clientX,
                          y: e.clientY,
                        });
                      }}
                    >
                      <div className={styles.dotsWrapperHover}>
                        <img
                          src={horizontalDots}
                          alt="horizontalDots"
                          className={`${styles.verticalDots} }`}
                        />
                        <div className={styles.shadowContainer} ></div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
              {searchTerm !== "" && !hasMatchingChats ? (
                <div className={styles.noFilesContainer}>
                  <h3>{t("noChatsMatchThisSearch")}</h3>
                </div>
              ) : Object.keys(sortChat).length === 0 || !hasMatchingChats ? (
                <div className={styles.noChats}>
                  <p>{t("currentlyHaveNoChats")}</p>
                  <p>{t("sendMessageStartChat")}</p>
                </div>
              ) : (
                Object.entries(sortChat).map(([group, chatArray]) => {
                  let groupTitle = t("ancient");

                  if (group == 0) groupTitle = t("today");
                  else if (group == 1) groupTitle = t("today");
                  else if (group > 1 && group < 7) groupTitle = t("thisWeek");
                  else if (group >= 7 && group < 14) groupTitle = t("lastWeek");
                  else if (group >= 14 && group < 30)
                    groupTitle = t("thisMonth");
                  else if (group >= 30 && group < 60)
                    groupTitle = t("lastMonth");
                  else if (group >= 60) groupTitle = t("severalMonthAgo");

                  const filteredChats = chatArray.filter(
                    (chat) =>
                      chat.agent === selectedAgent._id &&
                      (chat.name || "")
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                  );

                  if (filteredChats.length === 0) return null;

                  return (
                    <div key={group}>
                      <div className={styles.groupTitle}    >
                        <strong>{groupTitle}</strong>
                      </div>
                      <ul>
                        {filteredChats

                          .sort((a, b) => b.pinned - a.pinned)
                          .map((chat) => (
                            <li
                              key={chat.id}
                              className={`${chatId === chat.id ? styles.active : ""}`}
                              onClick={() => {
                                localStorage.setItem("selectedChatId", chat.id);
                                navigate(
                                  `/admin/chat/${agentId || selectedAgent._id}/${chat.id}`
                                );
                              }}
                            >
                              {selectedChat != chat?.id ? (
                                <>
                                  <span>
                                    {tempChatNames[chat.id] ||
                                      chat.name ||
                                      t("newChat")}
                                  </span>
                                  <div className={styles.pinnedIcon}>
                                    {chat.pinned ? <Pinned className={styles.pinnedIconSvg} /> : <NotPinned />}
                                  </div>
                                </>
                              ) : (
                                <input
                                  ref={(el) => (inputRefs.current[chat.id] = el)}
                                  type="text"
                                  value={tempChatNames[chat.id] || ""}
                                  className={
                                    selectedChat == chat?.id &&
                                    styles.selectedChat
                                  }
                                  onBlur={(e) => {
                                    setSelectedChat(null);
                                    handleChageNameChat(
                                      chat.id,
                                      tempChatNames[chat.id]
                                    );
                                  }}
                                  onChange={(e) =>
                                    setTempChatNames((prev) => ({
                                      ...prev,
                                      [chat.id]: e.target.value,
                                    }))
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      setSelectedChat(null);
                                      handleChageNameChat(
                                        chat.id,
                                        tempChatNames[chat.id]
                                      );
                                    }
                                  }}
                                />
                              )}
                              <div className={styles.chatMenuSettings}>
                                <button
                                  className={styles.moreButton}
                                  onClick={(e) => {
                                    setOptionsSelectedAgent(false);
                                    setSelectedOption({
                                      chat,
                                      x: e.clientX,
                                      y: e.clientY,
                                    });
                                  }}
                                >

                                  <div className={styles.dotsWrapperHoverHorizontal}>
                                    <img src={horizontalDots} alt="horizontalDots" />
                                    <div className={styles.shadowContainerHorizontal} ></div>
                                  </div>

                                  {" "}
                                </button>
                              </div>
                            </li>
                          ))}
                      </ul>
                    </div>
                  );
                })
              )}
            </>
          )}

          {!selectedAgent && (
            <div className={styles.agentsContainer}>
              {filteredAgents?.length > 0 ? (
                <ul>
                  {[...filteredAgents]
                    .filter((agent) => agent.type !== "public")
                    .sort((a, b) => b.pinned - a.pinned)
                    .map((agent) => (
                      <li
                        key={agent._id}
                        onClick={() => {
                          dispatch(setSelectedAgent(agent));
                          setImage(agent.image);
                          localStorage.setItem("selectedAgentId", agent._id);
                          localStorage.removeItem("selectedChatId");
                          navigate(`/admin/chat/${agent._id}`);
                        }}
                      >
                        <div className={styles.agentInfo}>
                          <img src={agent?.image || ImageEmpty} alt="" />
                          <p className={styles.agentNameQuantityConversations}>
                            {agent?.name || t("newAgent")}
                            <span>
                              {t("have")}{" "}
                                {/* numnero de chats */}
                              {
                              agent.totalChats || 0
                              }{" "}
                              {t("conversations")}
                            </span>
                          </p>
                        </div>
                        <div className={styles.pinnedIcon}>
                          {agent?.pinned ? <Pinned className={styles.pinnedIconSvg} /> : <NotPinned />}
                        </div>
                        <div className={styles.chatMenuSettings}>
                          <button
                            className={styles.moreButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedOption({
                                agent,
                                x: e.clientX,
                                y: e.clientY,
                              });
                            }}
                          >
                            <div className={styles.dotsWrapperHoverHorizontal}>
                              <img src={horizontalDots} alt="options" />
                              <div className={styles.shadowContainerHorizontal} ></div>
                            </div>
                          </button>
                        </div>
                      </li>
                    ))}

                  {[...filteredAgents].some((agent) => agent.type === "public") && (
                    <li className={`${styles.liSinHover}`}>
                      <strong>{t("publicAgents")}</strong>
                    </li>
                  )}

                  {[...filteredAgents]
                    .filter((agent) => agent.type === "public")
                    .sort((a, b) => b.pinned - a.pinned)
                    .map((agent) => (
                      <li
                        key={agent._id}
                        onClick={() => {
                          dispatch(setSelectedAgent(agent));
                          setImage(agent.image);
                          localStorage.setItem("selectedAgentId", agent._id);
                          localStorage.removeItem("selectedChatId");
                          navigate(`/admin/chat/${agent._id}`);
                        }}
                      >
                        <div className={styles.agentInfo}>
                          <img src={agent?.image || ImageEmpty} alt="" />
                          <p className={styles.agentNameQuantityConversations}>
                            {agent?.name || t("newAgent")}
                            <span>
                              {t("have")}{" "}
                              {
                               agent.totalChats || 0
                              }{" "}
                              {t("conversations")}
                            </span>
                          </p>
                        </div>
                        <div className={styles.pinnedIcon}>
                          {agent?.pinned ? <Pinned className={styles.pinnedIconSvg} /> : <NotPinned />}
                        </div>
                        <div className={styles.chatMenuSettings}>
                          <button
                            className={styles.moreButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedOption({
                                agent,
                                x: e.clientX,
                                y: e.clientY,
                              });
                            }}
                          >
                            <div className={styles.dotsWrapperHoverHorizontal}>
                              <img src={horizontalDots} alt="options" />
                              <div className={styles.shadowContainerHorizontal} ></div>
                            </div>
                          </button>
                        </div>
                      </li>
                    ))}
                </ul>
              ) : (
                <div className={styles.noFilesContainer}>
                  <h3>{t("noAgentsfound")}</h3>
                </div>
              )}
            </div>
          )}
        </div>
        {selectedOption && (
          <ul
            className={styles.menuOptions}
            style={{
              top: selectedOption.y,
              left: selectedOption.x,
            }}
          >
            {!selectedAgent || optionsSelectedAgent ? (
              <>
                {user?.id?.split("_").pop() === agent?.createdBy && agent?.type !== "public" && (

                  <li
                    onClick={() => {
                      if (selectedAgent) {
                        dispatch(setSelectedAgent(selectedAgent));
                        // setIdSelectedAgent(selectedAgent._id);
                        // setChatAgentId(selectedAgent._id);
                        navigate(`/admin/agent/${selectedAgent._id}`);
                        // dispatch(setFatherNewAgent("agent"));
                      } else {
                        dispatch(setSelectedAgent(selectedOption.agent));
                        // setIdSelectedAgent(selectedOption.agent._id);
                        // setChatAgentId(selectedOption.agent._id);
                        navigate(`/admin/agent/${selectedOption.agent._id}`);
                        // dispatch(setFatherNewAgent("chat"));
                      }
                      setSelectedOption(null);
                    }}
                  >
                    {t("editAgent")}
                  </li>
                )}
                <li
                  onClick={async () => {
                    if (selectedAgent) {
                      if (user?.id?.split("_").pop() !== agent?.createdBy) {
                        const res = await dispatch(duplicateAgent({ agent: agent }))
                        if (res) dispatch(getAgents({ token }));
                      } else {

                        handleTogglePinned(
                          selectedAgent._id,
                          selectedAgent.pinned
                        );
                        dispatch(setSelectedAgent((prev) => ({
                          ...prev,
                          pinned: !prev.pinned,
                        })));
                      }
                    } else {
                      if (user?.id?.split("_").pop() !== agent?.createdBy) {
                        const res = await dispatch(duplicateAgent({ agent: agent }))
                        if (res) dispatch(getAgents({ token }));
                      } else {

                        handleTogglePinned(
                          selectedOption.agent._id,
                          selectedOption.agent?.pinned
                        );
                      }
                    }
                    setSelectedOption(null);
                  }}
                >

                  {agent?.pinned ? `${t("unpin")} `
                    : `${t("pin")} `}
                  {t("agent")}
                </li>
                {user?.id?.split("_").pop() === agent?.createdBy && agent?.type !== "public" && (
                  <li
                    onClick={async () => {
                      setSelectedChatAgentToDelete(
                        selectedAgent ? selectedAgent : selectedOption?.agent
                      );

                      dispatch(setShowModal({
                        modal: 'deleteChats',
                        type: 'agents',
                        variant: 'confirm',
                        selectedOption: selectedAgent ? selectedAgent : selectedOption?.agent
                      }))
                      // setShowDeleteChatsAgents(true);
                      // setSTypeDeleteChatsAgents("agents");
                      // setVarianteDeleteChatsAgent('confirm')
                      dispatch(setSelectedAgent(null));
                      setSelectedOption(null);
                      dispatch(getAgents({}));
                    }}
                  >
                    {t("deleteAgent")}
                  </li>
                )}
                {user?.id?.split("_").pop() === agent?.createdBy && agent?.type !== "public" && (
                  <li
                    onClick={async () => {
                     chatList.forEach((chat) => {
                      if (chat.agent == agent._id) dispatch(deleteChat({ chatId: chat.id }))
                     })
                     dispatch(setEmptyChat("all"))
                     setSelectedOption(null);
                    }}
                  >
                    {t("emptyAgent")}
                  </li>
                )}
              </>
            ) : (
              <>
                <li onClick={() => {

                  // dispatch(setShowModal('deleteChats'))

                  dispatch(setShowModal({
                    modal: 'deleteChats',
                    type: 'chats',
                    variant: 'simple',
                    selectedOption: selectedOption.chat
                  }))


                  // setShowDeleteChatsAgents(true)
                  // setSTypeDeleteChatsAgents("chats");
                  // setVarianteDeleteChatsAgent('simple')
                  // setSelectedChatAgentToDelete(
                  //   selectedOption.chat
                  // );
                  // setSelectedOption(null);
                  // handleDeleteMessage(selectedOption.chat)
                }}>
                  {/* showDeleteChatsAgents */}
                  {t("deleteChat")}
                </li>
                <li
                  onClick={() =>
                    handleTogglePinnedChat(
                      selectedOption.chat.id,
                      selectedOption.chat.pinned
                    )
                  }
                >
                  {selectedOption.chat.pinned ? t("unpin") : t("pin")}{" "}
                  {t("chat")}
                </li>
                <li onClick={() => handleChangeName(selectedOption.chat?.id)}>
                  {t("changeName")}
                </li>
                 <li onClick={async () =>{
                  
                 await dispatch(emptyChat({chatId: currentChat.id}))
                 await dispatch(setEmptyChat(currentChat.id))
                 setSelectedOption(null);
                  }}>
                  {t("emptyChat")}
                </li>
              </>
            )}
          </ul>
        )}
        
         <div className={styles.imageHover} onClick={(e) => { e.stopPropagation()
          selectedAgent? onClicNewChat(e) : addMessage()
            }}>
          {/*aca*/}
          {selectedAgent ?  <img 
          // onClick={(e) => { e.stopPropagation();            onClicNewChat(e)}} 
            className={styles.searchContainerL} src={newChatWithAgent} alt="newChatIcon" />
            : <>
            <img
            src={agentNewIcon}
            className={styles.searchContainerL}
            // onClick={() => addMessage()}
            />
            {/* {count > 0 && (
                <div className={styles.count}>
                  {count}
                </div>
              )} */}
            </>
          }
          {/* <div className={styles.shadowContainerSearch} ></div> */}
          <div>{selectedAgent ? t('newChat') : t('newAgent')  }</div>
          </div>
        <div className={styles.communitiContainer}>
          <button onClick={(e) => {
            e.stopPropagation()
            // setShowExplore(true)
            // dispatch(setShowModal('exploreCommunity'))
            navigate('/admin/marketplace')
          }} className={styles.communiti}>
            <ExploreCommunitiIcon /> {t("exploreCommunity")}
          </button>
        </div>
      </div>
      {/* {showExplore && (
          <ExploreCommuniti setShowExplore={setShowExplore} />
        )} */}
    </div>
  );
};



export default ChatExplorer;